import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FAQSection = () => {
  const [open, setOpen] = useState(null);
  const { t } = useTranslation();
  const f = t('home.faq', { returnObjects: true });

  return (
    <section data-testid="faq-section" className="py-16 md:py-24 border-t border-white/5">
      <div className="container-custom max-w-3xl">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold font-['Syne'] text-white">{f.title}</h2>
        </motion.div>

        <div className="space-y-3">
          {f.items.map((faq, idx) => (
            <div key={idx} className="border border-white/10 rounded-xl overflow-hidden bg-white/[0.02]">
              <button onClick={() => setOpen(open === idx ? null : idx)} data-testid={`faq-${idx}`} className="w-full flex items-center justify-between p-5 text-left">
                <span className="text-white font-medium pr-4">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform ${open === idx ? 'rotate-180' : ''}`} />
              </button>
              <AnimatePresence>
                {open === idx && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }} className="overflow-hidden">
                    <p className="px-5 pb-5 text-gray-400 text-sm leading-relaxed">{faq.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-white/40 text-sm">{f.notListed} <Link to="/contact" className="text-[#c8ff00] underline underline-offset-2">{f.askDirectly}</Link></p>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
